import { giphyDarkCharcoal, giphyLightGrey } from '@giphy/colors'
import styled from 'styled-components'
import { IconComponent } from 'ui'
import PresetComponent from '../preset'
import ButtonComponent from './button'
import OptionsComponent from './options'
import PresetsComponent from './presets'

export const Button = styled(ButtonComponent)`
    width: 220px;
`

export const Container = styled.div`
    align-items: center;
    display: flex;
`

export const Dropdown = styled.div`
    box-sizing: border-box;
    padding: 15px 15px 5px;
`

export const Icon = styled(IconComponent)`
    display: inline-block;
    margin-right: 5px;
    vertical-align: middle;
`

export const Options = styled(OptionsComponent)`
    border-top: 1px solid ${giphyDarkCharcoal};
    padding: 15px 0;
`

export const Preset = styled(PresetComponent)<{ $active: boolean }>`
    font-weight: ${({ $active }) => ($active ? 'bold' : 'normal')};
`

export const Presets = styled(PresetsComponent)`
    padding: 15px 0;
`

export const Title = styled.div`
    color: ${giphyLightGrey};
    font-size: 15px;
    font-weight: bold;
    margin-right: 10px;
`
